import { useState } from "react";
import { toast } from "sonner";
import { ArrowRight } from "lucide-react";
import api, { apiErr } from "@/lib/api";
import { BrushUnderline } from "@/components/public/Brush";

export default function Newsletter({ headline, subtext, compact = false }) {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/public/newsletter", { email });
      setDone(true); toast.success("You are on the list. Talk soon."); setEmail("");
    } catch (err) { toast.error(apiErr(err)); }
    finally { setLoading(false); }
  };

  return (
    <div data-testid="newsletter" className={`relative overflow-hidden border border-ink-600 texture-concrete ${compact ? "p-7" : "p-9 lg:p-14"}`}>
      <div className="absolute top-0 left-0 w-1.5 h-full bg-brand" />
      <div className="absolute -bottom-24 -right-16 w-72 h-72 rounded-full bg-brand/10 blur-3xl pointer-events-none" />
      <div className="relative max-w-2xl">
        <div className="label-mono mb-3">// The List</div>
        <h3 className="font-poster uppercase text-white leading-[0.92] text-3xl lg:text-5xl">
          {headline || <>ONE GOOD IDEA. <span className="relative inline-block text-brand">EVERY WEEK.<BrushUnderline className="absolute left-0 -bottom-2 w-full h-3 text-brand" /></span></>}
        </h3>
        <p className="text-white/60 mt-4 text-base lg:text-lg">{subtext || "No spam, no hype. Just practical things worth trying."}</p>
        {done ? (
          <p className="mt-6 font-hand text-brand text-2xl" data-testid="newsletter-success">You are in. Check your inbox soon.</p>
        ) : (
          <form onSubmit={submit} className="mt-7 flex flex-col sm:flex-row gap-0 max-w-md">
            <input type="email" required data-testid="newsletter-email-input" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="you@email.com"
              className="flex-1 bg-ink-950 border-2 border-ink-600 px-5 py-3.5 text-sm text-white placeholder:text-white/40 outline-none focus:border-brand transition-colors" />
            <button type="submit" disabled={loading} data-testid="newsletter-submit" className="btn-poster justify-center disabled:opacity-60">
              <span>{loading ? "..." : "JOIN"}</span><ArrowRight size={16} className="relative z-10" />
            </button>
          </form>
        )}
      </div>
    </div>
  );
}
